export class CustoMensagemWhatsapp {
  id?: number;
  codigoPais!: string;
  categoriaCobranca!: string;
  custo!: number;
  moeda: 'BRL' | 'USD' | 'EUR' = 'USD';

  createdAt?: string;
  updateAt?: string;
  createdByNome?: string;
  updatedByNome?: string;
}
